// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__65LMC","spin":"styles_spin__ul8p8"};